import { useAppSelector } from './redux-hooks';
import { localizeDish } from '../localization/apply';

export function useLocalizedContent() {
    const { menu, selectedDish, locale, showLanguageSwitcher } = useAppSelector(
        (state) => state.menu
    );
    return {
        menu,
        selectedDish: selectedDish ? localizeDish(selectedDish, locale) : null,
        locale,
        showLanguageSwitcher,
    };
}
